export const ownership = {
  id: 1,
  name: "Ownership",
  slug: "ownership",
  status: "on track",
  description: "Black ownership equity, voting rights, and economic interest verification",
  deadline: "31 Jan 2026",
  current_points: 22.5,
  total_points: 27,
  target: 25,
  workflow_completed: 2,
  workflow_total: 6,
  icon: "fas fa-users",
  theme: { gradientFrom: "#22c55e", gradientTo: "#14b8a6" },
  steps: [
    {
      id: "own-1",
      title: "Obtain Share Certificates",
      description:
        "Collect certified copies of all share certificates reflecting current shareholding structure",
      status: "completed",
      due: "10 Jan 2026",
      owner_initials: "SN",
      owner_name: "Sarah Nkosi",
      owner_role: "Company Secretary",
      owner_email: "sarah.nkosi@company.co.za",
      owner_number: "+27 82 123 4567",
      owner_role_desc: "Manages share registry and CIPC filings",
      required_documents: ["Share Certificates", "CIPC CM29 Form"],
    },
    {
      id: "own-2",
      title: "Compile Shareholders Agreement",
      description:
        "Ensure shareholders agreement is signed and reflects all voting rights and economic interests",
      status: "completed",
      due: "15 Jan 2026",
      owner_initials: "DM",
      owner_name: "David Mokoena",
      owner_role: "Legal Advisor",
      owner_email: "david.mokoena@lawfirm.co.za",
      owner_number: "+27 83 234 5678",
      owner_role_desc: "Ensures legal compliance and documentation",
      required_documents: ["Shareholders Agreement", "Voting Rights Declaration"],
    },
    {
      id: "own-3",
      title: "Update Memorandum of Incorporation",
      description:
        "Verify MOI reflects current share structure and any amendments are registered with CIPC",
      status: "in_progress",
      due: "20 Jan 2026",
      owner_initials: "DM",
      owner_name: "David Mokoena",
      owner_role: "Legal Advisor",
      owner_email: "david.mokoena@lawfirm.co.za",
      owner_number: "+27 83 234 5678",
      owner_role_desc: "Ensures legal compliance and documentation",
      required_documents: ["Memorandum of Incorporation", "CIPC Amendment Proof"],
    },
    {
      id: "own-4",
      title: "Collect Shareholder ID Documents",
      description:
        "Collect certified ID copies and proof of address for all black shareholders",
      status: "pending",
      due: "25 Jan 2026",
      owner_initials: "TM",
      owner_name: "Thabo Molefe",
      owner_role: "HR Manager",
      required_documents: ["Certified ID Copies", "Proof of Address"],
    },
    {
      id: "own-5",
      title: "Calculate Ownership Points",
      description:
        "Calculate black ownership percentage and scorecard points using flow-through principle",
      status: "pending",
      due: "28 Jan 2026",
      owner_initials: "LZ",
      owner_name: "Lindiwe Zulu",
      owner_role: "BEE Consultant",
      owner_email: "lindiwe.zulu@beeconsultants.co.za",
      owner_number: "+27 89 890 1234",
      owner_role_desc: "Provides BEE score calculations and compliance advice",
      required_documents: ["Ownership Calculation Workbook", "Flow-through Analysis"],
    },
    {
      id: "own-6",
      title: "Submit Ownership Pack for Verification",
      description:
        "Compile and submit full ownership evidence pack to verification agency",
      status: "pending",
      due: "31 Jan 2026",
      owner_initials: "JD",
      owner_name: "John Dlamini",
      owner_role: "BEE Manager",
      owner_email: "john.dlamini@company.co.za",
      owner_number: "+27 90 901 2345",
      owner_role_desc: "Oversees all BEE compliance and verification processes",
      required_documents: ["Complete Ownership Pack", "Supporting Affidavits"],
    },
  ],
};
